import { useAccountMeAuthApi } from '@/shared/apis/account/account-me';
import { useAuthInitialized } from '@/shared/provider/AuthProvider';
import { useTokenStore } from '@/shared/store/token-store';
import { getAccountIdFromAccessToken } from '@/shared/utils/access-token';

interface UseFeatureEnabledOptions {
  /** false면 디버그 진입점처럼 로컬 Operator OFF override 전의 서버 권한을 판정한다. */
  respectOperatorOverride?: boolean;
  /** false면 AuthProvider 바깥에서도 account query 자체의 로딩 상태로 판정한다. */
  waitForAuthInitialization?: boolean;
}

export const useFeatureEnabled = (options: UseFeatureEnabledOptions = {}) => {
  const { isAuthInitialized } = useAuthInitialized();
  const respectOperatorOverride = options.respectOperatorOverride ?? true;
  const waitForAuthInitialization = options.waitForAuthInitialization ?? true;
  const { accessToken, switchAccessToken } = useTokenStore();
  const { data: account, isLoading: isAccountLoading } = useAccountMeAuthApi(
    respectOperatorOverride
      ? undefined
      : {
          select: (response) => response,
          placeholderData: undefined,
        },
  );

  const activeAccountId = getAccountIdFromAccessToken(
    switchAccessToken ?? accessToken,
  );
  const isAccountForCurrentToken =
    activeAccountId == null || account?.data.id === activeAccountId;

  const isLoading =
    (waitForAuthInitialization && !isAuthInitialized) || isAccountLoading;

  return {
    enable:
      !isLoading &&
      isAccountForCurrentToken &&
      account?.data.hasOperatorRole === true,
    isLoading,
  };
};
